import { render } from "./JobList.vue?vue&type=template&id=74e67823&scoped=true&ts=true"
import script from "./JobList.vue?vue&type=script&lang=ts"
export * from "./JobList.vue?vue&type=script&lang=ts"

import "./JobList.vue?vue&type=style&index=0&id=74e67823&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e67823"]])

export default __exports__